import { apiClient } from "./client";

export async function login(email, password) {
  const res = await apiClient.post("/v1/auth/", { email, password });
  return res.data?.data || res.data;
}
